// extracted by mini-css-extract-plugin
export default {"container":"RMBMwRm8mGOJHE5gIogw","textarea-wrapper":"S2IC84FaCvnyiL5pi6gE","wide":"lCV964EDd6cs0jqPzGYQ","narrow":"M_iETO4nhkZK0vGWOrrG","short":"lXPeu_UX6MmeM5GYn4JX"};